import { IFont } from '../../data/fonts';

export const DEFAULT_FONT_INDEX = -1;

export const NO_FONT = {
  id: DEFAULT_FONT_INDEX,
  digits: [],
  upper: [],
  lower: [],
} as IFont;
